import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 delete_employee_from_ready_for_disaptch_Settings: { message: "idle" },
};

export const delete_employee_from_ready_for_disaptch_Settings_Slice = createSlice({
 name: "delete_employee_from_ready_for_disaptch_Settings",
 initialState,
 reducers: {
  success_delete_employee_from_ready_for_disaptch_Settings: (state, action) => {
   state.delete_employee_from_ready_for_disaptch_Settings = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_delete_employee_from_ready_for_disaptch_Settings: (state, action) => {
   state.delete_employee_from_ready_for_disaptch_Settings = { status: app_consts.FAIL, message: action.payload };
  },
  reset_delete_employee_from_ready_for_disaptch_Settings: (state) => {
   state.delete_employee_from_ready_for_disaptch_Settings = { status: app_consts.IDLE };
  },
  loading_delete_employee_from_ready_for_disaptch_Settings: (state) => {
   state.delete_employee_from_ready_for_disaptch_Settings = { status: app_consts.LOADING };
  },
 }
});

export const { success_delete_employee_from_ready_for_disaptch_Settings, fail_delete_employee_from_ready_for_disaptch_Settings, reset_delete_employee_from_ready_for_disaptch_Settings, loading_delete_employee_from_ready_for_disaptch_Settings } = delete_employee_from_ready_for_disaptch_Settings_Slice.actions;

export default delete_employee_from_ready_for_disaptch_Settings_Slice.reducer;